// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStateHook } from '@atlassian/react-sweet-state';
import type { Actions } from './actions.tsx';
import { DeleteIssueModalStore } from './main.tsx';
import type { State } from './types.tsx';

export const useDeleteIssueModalStates = createStateHook<State, Actions>(DeleteIssueModalStore);
